import { ITax } from '@smsamiinc/esc-receipt';
import { SetTimeForOrg } from 'src/app/interfaces/orgTime';

import { ITaxProfile } from '../../interfaces/tax-profile';
export interface IwareHouse {
    name: string;
    comments: string;
}
export interface IreceiptNote {
    dine_in: string;
    delivery: string;
    food_panda: string;
    take_away: string;
    jovi: string;
}
export interface IreceiptNotePayload {
    data: IreceiptNote;
    is_enable: boolean;
}
// tslint:disable-next-line: no-namespace
export namespace OrgAction {
    export class Self {
        static readonly type = '[Org] Self';
        constructor() {}
    }

    export class UpdateProfile {
        static readonly type = '[Org] UpdateProfile';
        constructor(public payload: any) {}
    }

    export class SetOrgTime {
        static readonly type = '[Org] SetOrgTime';
        constructor(public payload: SetTimeForOrg) {}
    }
    export class SetReceiptNote {
        static readonly type = '[Org] SetReceiptNote';
        constructor(public payload: IreceiptNotePayload) {}
    }
    export class UpdateWareHouse {
        static readonly type = '[Org] UpdateWarehouse';
        constructor(public payload: IwareHouse) {}
    }
    export class GetAllTaxProfile {
        static readonly type = '[Profile] GetAllTaxProfile';
        constructor(public payload: ITaxProfile) {}
    }
    export class AddTaxProfile {
        static readonly type = '[Profile] Add TaxProfile';
        constructor(public payload: { organizationId: string; profileData: ITaxProfile }) {}
    }

    export class updateTaxProfile {
        static readonly type = '[Profile] update TaxProfile';
        constructor(public payload: { organizationId: string; profileData: ITaxProfile }) {}
    }
    export class deleteTaxProfile {
        static readonly type = '[Profile] Delete TaxProfile';
        constructor(public payload: { organizationId: string; taxId: string }) {}
    }
}
